import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useSnackbar } from "notistack";
import DialogTitleComponent from "../../../../components/dialog_title";
import { Eliminar } from "../../../../services/request/reclutamiento/seleccionables";

export default function DialogDelete(props) {
	const {
		is_open,
		data,
		handle_close,
		mutate_licencias_conducir,
	} = props;

	const notistack = useSnackbar();

	const handleDelete = async () => {
		try {
			notistack.enqueueSnackbar("Eliminando la licencia de conducir...", {
				anchorOrigin: {
					horizontal: "center",
					vertical: "bottom"
				},
			});
			await Eliminar(data._id);
			notistack.closeSnackbar();
			notistack.enqueueSnackbar("Licencia de conducir eliminada exitosamente.", {
				variant: "success",
				anchorOrigin: {
					horizontal: "center",
					vertical: "bottom"
				},
				action: (key) => <IconButton onClick={() => notistack.closeSnackbar(key)}><CloseIcon /></IconButton>
			});
		} catch (error) {
			console.error(error);
			notistack.enqueueSnackbar("Error al intentar eliminar la licencia de conducir.", {
				variant: "error",
				anchorOrigin: {
					horizontal: "center",
					vertical: "bottom"
				},
				action: (key) => <IconButton onClick={() => notistack.closeSnackbar(key)}><CloseIcon /></IconButton>
			});
		} finally {
			mutate_licencias_conducir();
			handle_close();
		}
	}

	return (
		<Dialog open={is_open} onClose={handle_close} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handle_close}>Eliminar Licencia de Conducir</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{`Debe confirmar la eliminación de la licencia de conducir "${data ? data.valor : ""}".`}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handle_close} color="primary">Cancelar</Button>
				<Button onClick={handleDelete} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}